/* global G */
import { curry, getFirstItem, isObj, isStr } from '@gaia/util'

/**
 * To String Transformer
 *
 * transforms input into a string
 *
 * @param {string} key          the name of the attribute to store the data to
 * @param {Gaia.Model.Spec} obj the current model object composition
 * @param {Object} data         the payload data processed until now
 * @returns {Object}             the payload data
 */
const fn = (key, obj, data) => {
  const _data = data

  try {
    const item = obj[G.CHILDREN][key]
    const { type } = item[G.PROPS]
    const { value } = item[G.DATA]
    const v = getFirstItem(value)

    _data[type][key] = (v && isObj(v) && v?.key)
      || (v && isStr(v) && v)
      || ''
  } catch (e) {
    console.error(e)
  }

  return _data
}

export default curry(fn)
